<template>
  <div class="wrapper">
    <jm-crumbs/>
    <div class="basic-title"><em>提交入管局时间</em></div>
    <el-form
      ref="form"
      :inline="true"
      label-width="80px">
      <el-row>
        <el-form-item label="年度">
          <el-date-picker
            v-model="config.year"
            align="left"
            type="year"
            format="yyyy"
            value-format="yyyy"
            :picker-options="yearOptions"
            placeholder="选择年度"
            @change="getYearConfig"
          />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="1月">
          <el-date-picker
            v-model="config.jan"
            align="left"
            type="date"
            :default-value="getDefaultVal(0)"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"/>
        </el-form-item>
        <el-form-item label="4月">
          <el-date-picker
            v-model="config.apr"
            align="left"
            type="date"
            :default-value="getDefaultVal(3)"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"/>
        </el-form-item>
        <el-form-item label="7月">
          <el-date-picker
            v-model="config.july"
            align="left"
            type="date"
            :default-value="getDefaultVal(6)"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"/>
        </el-form-item>
        <el-form-item label="10月">
          <el-date-picker
            v-model="config.oct"
            align="left"
            type="date"
            :default-value="getDefaultVal(9)"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"/>
        </el-form-item>
      </el-row>
      <el-form-item>
        <el-button
          @click="saveConfig"
          type="primary">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      yearOptions: {
        disabledDate(time) {
          return time.getFullYear() < (new Date()).getFullYear();
        }
      },
      config: {
        year: null,
        jan: null,
        apr: null,
        july: null,
        oct: null
      }
    };
  },
  methods: {
    getDefaultVal(month) {
      return (new Date()).setMonth(month);
    },
    getYearConfig(year = null) {
      let data = {};

      if (year) {
        data.year = year;
      }

      if (this.$route.meta.c === 'qcrb') {
        data.qcrb = true;
      }

      this.$http._get({
        url: '/index/jp_process/getYearConfig',
        data,
      }).then(({ data }) => {
        this.config = { ...data, year: String(data.year) };
      });
    },
    saveConfig() {
      this.$http._post({
        url: '/index/jp_process/saveConfig',
        data: this.config
      }).then(() => {
        this.$message.success('保存成功');
      });
    }
  },
  mounted() {
    this.getYearConfig();
  },
};
</script>
